import { whenWeglotReady } from '@theme/utilities';

/**
 * TrueFit's own widget scan is switched off in snippets/true-fit-script.liquid whenever
 * Weglot is active, because Weglot resolves the language only after that scan would have
 * run and which of the two wins varies per page load. This module is the single trigger:
 * it waits for the language, then hands it to tfFirstScan, which applies it and scans.
 *
 * The widget's copy lives in a cross-origin iframe Weglot cannot reach, so TrueFit's own
 * `locale` is the only channel — and Shopify publishes `en` alone, so Liquid cannot fill it.
 */

/** Primary subtag — Weglot reports a regional code here (`fr-ca`), TrueFit takes `fr`. */
const toLang = (code) => (code ?? '').split('-')[0].toLowerCase();

const run = async () => {
  let lang = '';

  // Weglot is third-party: whenWeglotReady calls getCurrentLang synchronously, so a throw in
  // there would reject this and leave the widget unscanned until the head deadline.
  try {
    await whenWeglotReady();
    lang = toLang(window.Weglot?.getCurrentLang());
  } catch (error) {
    console.error('TrueFit locale: reading the Weglot language failed', error);
  }

  // Empty means Weglot never resolved; TrueFit then falls back to the rendered data-locale.
  window.tfFirstScan?.(lang);
};

void run();
